var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioMute(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "turn-microphone-off-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.144,
    height: 20.207,
    viewBox: "0 0 19.144 20.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic-off",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9637",
    "data-name": "Path 9637",
    d: "M369.433,229.5h-1.808a6.878,6.878,0,0,1-.425,2.127l1.276,1.276A6.073,6.073,0,0,0,369.433,229.5Z",
    transform: "translate(-352.417 -219.928)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9638",
    "data-name": "Path 9638",
    d: "M172.131,9.785V3.191a3.191,3.191,0,1,0-6.381,0V3.4Z",
    transform: "translate(-159.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9639",
    "data-name": "Path 9639",
    d: "M14.133,25.5,12.75,26.883l6.381,6.381v.744A3.134,3.134,0,0,0,22.322,37.2a2.076,2.076,0,0,0,.744-.106L24.874,38.9a6.309,6.309,0,0,1-2.446.532,5.492,5.492,0,0,1-5.637-5.424H14.877a7.4,7.4,0,0,0,6.381,7.126v3.51h2.127v-3.51a7.217,7.217,0,0,0,2.659-.957l4.467,4.467,1.383-1.383Z",
    transform: "translate(-12.75 -24.436)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMute);
export default __webpack_public_path__ + "static/media/audio-mute.a03dd35b31e459d2b81c4252232b96bd.svg";
export { ForwardRef as ReactComponent };